import { render, staticRenderFns } from "./admin.role.vue?vue&type=template&id=9cae7b80&"
import script from "./admin.role.vue?vue&type=script&lang=js&"
export * from "./admin.role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports